import * as React from 'react'

import {
  type DefaultOptionProps,
  type LabeledInputProps,
  type NoneProps,
  type OptionGroupsProps,
  SelectField,
} from '@factorialco/deprecated-design-system'
import type { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type { SelectProps } from '../types'

type Props = LabeledInputProps &
  DefaultOptionProps &
  OptionGroupsProps &
  NoneProps &
  Omit<SelectProps, 'onChange' | 'missingLabel' | 'selectValue'> & {
    field: Field
    error?: string
    readonly?: boolean
    onChange?: (field: Field) => void
    missingLabel?: string
    extra?: React.ComponentProps<typeof SelectField>['extra']
  }

const Select = ({
  mandatory = false,
  secondaryLabel,
  description,
  none,
  field,
  label,
  hideLabel = false,
  readonly,
  showOriginalLabelText,
  options,
  onFocus,
  onBlur,
  onChange,
  defaultOption,
  defaultValue,
  autofilled = false,
  missingLabel,
  extra,
}: Props) => {
  const error = field.errors && field.errors[0]

  const onChangeEvent = (value: string) => {
    field.set(field.type === 'boolean' ? value === 'true' : value)
    onChange && onChange(field)
  }

  return (
    <SelectField
      mandatory={mandatory}
      label={label}
      hideLabel={hideLabel}
      value={field.value === '' || field.value === null ? undefined : field.value} //We dont override false or 0
      error={error || undefined}
      readonly={readonly}
      description={description}
      secondaryLabel={secondaryLabel}
      none={none}
      defaultOption={defaultOption}
      options={options}
      onBlur={onBlur}
      onFocus={onFocus}
      onChange={onChangeEvent}
      showOriginalLabelText={showOriginalLabelText}
      defaultValue={defaultValue}
      autofilled={autofilled}
      missingLabel={missingLabel ?? i18n.t('common.missing_field')}
      selectValue={i18n.t('common.select')}
      extra={extra}
    />
  )
}

export default observer(Select)
